import React, { useEffect, useState } from 'react'
import ResponsivePaginationComponent from 'react-responsive-pagination'
import ActuCard from '../components/ActuCard';
import { useQuery } from '@tanstack/react-query';
import { fetchArticles } from '../api/article';
import IsEmpty from '../components/IsEmpty';
import ActuCardPlaceholder from '../components/ActuCardPlaceholder';
import { getFirstImageSrc, getTextFromHTML } from '../constants/functions';
import { actualitiesLink } from '../constants/endspoints';
import { placeholderImg } from '../constants/files';
import { fetchCategories, fetchCategoryById } from '../api/categories';


const Actuality = () => {

    const [category, setCategory] = useState()
    const [currentPage, setCurrentPage] = useState(1);

    // 1. Fetch All actualities
    const { data: actualitiesData, status } = useQuery({
        queryKey: ["actualities", {page: currentPage}],
        queryFn: () => fetchArticles({'order[id]':"desc", page: currentPage, status: true}),
    });

    // 2. Fetch All categories
    const { data: categoriesData } = useQuery({
        queryKey: ['categories'],
        queryFn: fetchCategories,
        retry: false,
    });


    // 3. Fetch All actualities by category
    const { data: actuCategory, isLoading: isFetchingActuCategory, isError: actuCategoryError } = useQuery({
        queryKey: ['categoryId', category],
        queryFn: () => fetchCategoryById(category),
        enabled: !!category,
        retry: 2,
    });


    // 4. store actualities in a state
    const [data, setData] = useState([]);
    useEffect(() => {
        if(actuCategory?.articles){
            setData(actuCategory?.articles.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).filter(item => item.status === true));
        }else if(actualitiesData?.data?.member?.length > 0){
            setData(actualitiesData?.data?.member);
        }else{
            setData([]);
        }
    }, [actuCategory, actualitiesData]);





    // 5. Pagination setup
    const itemsPerPage = 8;
    const totalPages = Math.ceil(((actuCategory?.articles ? actuCategory?.articles?.length: actualitiesData?.data?.totalItems) || 1) / itemsPerPage);
    const [actualities, setActualities] = useState();

    useEffect(() => {
        setActualities(data);
    }, [data]);


    function handlePageChange(page) {
        setCurrentPage(page);

        window.scrollTo({ top: 0, behavior: 'instant' });
    }


    return (
        <div className='text-white mb-5 actualities'>

            {/* Hero */}
            <div className='bgcolor-hero-actuality mb-4'>
                <div className='container-xxl h-100'>
                    <div className=' d-flex flex-column justify-content-end align-items-center text-center h-100 w-100 mx-auto' style={{maxWidth:'576px'}}>
                        <h2 className=' fs-2 text-uppercase fw-bold'>Ubiznews tv-OM5</h2>
                        <p className=' fw-medium mb-0 fs-6 mb-1'>Au cœur  de l'information au quotidien</p>
                    </div>
                </div>
            </div>

            {/* Main content || Actualities list */}
            <div className='container-xxl'>

                <div className=' d-flex justify-content-between align-items-center'>
                    <h1 className='fs-3 text-nowrap text-uppercase fw-bold me-md-0 me-2'>Nos articles</h1>
                    <div className=' d-flex flex-nowrap align-items-center mb-1'>
                        <h3 className='fs-5 fw-bold me-2 mb-0 d-sm-block d-none'>Catégorie :</h3>
                        <div className='inputBox mt-0'>
                            <select 
                                name='category' 
                                onChange={(e)=>{setCategory(e.target.value); setCurrentPage(1)}} 
                                value={category} 
                                className='w-100 fs-9s bg-black'
                                style={{padding: "0.25rem !important"}}
                            >
                                <option value={''} className='text-capitalize fs-9s' defaultValue>Tous </option>
                                {categoriesData?.data?.length !== 0 ?
                                    categoriesData?.data?.map((cat, index) => (
                                        <option key={index} value={cat.id} className='fs-9s'>{cat.name}</option>
                                    ))
                                :
                                <option value={''}>--Aucune valeur--</option>
                                }
                            </select>
                        </div>
                    </div>
                </div>
                <hr className='mt-0 mb-1 border-white opacity-100'/>
                <p className='mb-0 fs-8s text-end'> « Page : {currentPage}/{totalPages} »</p>

                <div className=' mb-3 row justify-content-start align-items-start'>

                    {
                        (status === "pending") || isFetchingActuCategory?
                        [1,2,3,4].map((item, index) => (
                            <div key={index} className='col-lg-3 col-md-4 col-sm-6 mt-3'>
                                <ActuCardPlaceholder/>
                            </div>
                        ))
                        :(status === "error") || actuCategoryError?
                            <IsEmpty icon={"fa-light fa-exclamation-circle mb-2"} message={"Une erreur c'est produite"} />
                        :actualities?.length <= 0 ?
                            <IsEmpty icon={"fa-light fa-newspaper"} message={"Aucune actualité enregistrée "} />
                        :actualities?.map((actuality, index) => {
                            return (
                                <div key={index} className='col-lg-3 col-md-4 col-sm-6 mt-4'>
                                    <ActuCard 
                                        image={getFirstImageSrc(actuality?.content)? getFirstImageSrc(actuality?.content) : placeholderImg }
                                        title={actuality?.title}
                                        category={actuality?.Category?.name}
                                        description={getTextFromHTML(actuality?.content)}
                                        link={`${actualitiesLink}/${actuality?.id}`}
                                        date={actuality?.createdAt}
                                    />
                                </div>
                            )
                        })
                    }
                </div>

                
                <div className=' d-flex justify-content-end'>
                    <ResponsivePaginationComponent
                    total={totalPages}
                    current={currentPage}
                    onPageChange={page => handlePageChange(page)}
                    />
                </div>

            </div>
        </div>
    )
    
    
    
    
}

export default Actuality